<template>
    <div>
        <ts-page-title
            :title="$t('phumVillage.pageTitle')"
            :breadcrumb="[
                { text: $t('home'), href: '/' },
                {
                    text: $t('phumVillage.pageTitle'),
                    active: true
                }
            ]"
        />
        <ts-panel>
            <ts-panel-wrapper
                class="tw-flex tw-items-center tw-justify-between"
            >
                <Button type="info" ghost @click="addNew">{{
                    $t("addNew")
                }}</Button>
                <div class="tw-justify-end tw-space-x-2">
                    <Input
                        search
                        v-model="search"
                        :placeholder="$t('phumVillage.search')"
                        :style="width"
                        @on-focus="() => (width = 'width: 500px')"
                        @on-blur="() => (width = 'width: 300px')"
                    />
                </div>
            </ts-panel-wrapper>
            <Table
                :columns="columns"
                :data="resources"
                size="small"
                :loading="loading"
                max-height="700"
                stripe
            >
                <template slot-scope="{ row }" slot="action">
                    <a
                        href="#"
                        class="text-primary ml-2"
                        @click.prevent="onEdit(row)"
                        v-tooltip="$t('edit')"
                    >
                        <Icon type="ios-create" size="20" />
                    </a>
                    <Poptip
                        confirm
                        :title="$t('areYouSure')"
                        @on-ok="onDelete(row)"
                        :transfer="true"
                        :ok-text="$t('yes')"
                        :cancel-text="$t('no')"
                    >
                        <a
                            class="ml-2 text-danger"
                            v-tooltip="$t('delete')"
                            :disabled="row._deleting"
                        >
                            <i
                                class="fas fa-circle-notch fa-spin"
                                v-if="row._deleting"
                            ></i>
                            <Icon type="ios-trash" size="20" v-else />
                        </a>
                    </Poptip>
                </template>
            </Table>
            <div class="tw-flex tw-items-center tw-justify-end tw-p-4">
                <ts-i-pagination
                    v-model="pagination"
                    @navigate="fetchData"
                ></ts-i-pagination>
            </div>

            <!-- form-action -->
            <Modal
                v-model="showForm"
                draggable
                sticky
                scrollable
                :mask="false"
                :footer-hide="true"
                :z-index="1022"
                :title="$t('phumVillage.pageTitle')"
            >
                <from-action
                    ref="form_action"
                    @cancel="clearEdit"
                    @fetchData="fetchData"
                />
            </Modal>
        </ts-panel>
    </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";
import FromAction from "./form";

export default {
    name: "phum-villageIndex",
    components: {
        FromAction
    },
    data() {
        return {
            loading: false,
            showForm: false,
            width: "width: 300px"
        };
    },
    computed: {
        ...mapState("corporate/phumVillage", ["resources", "pagination"]),
        search: {
            get() {
                return this.$store.state.corporate.phumVillage.search;
            },
            set(newValue) {
                this.$store.commit(
                    "corporate/phumVillage/SET_SEARCH",
                    newValue
                );
                this.$store.commit("corporate/phumVillage/RESET_CURRENT_PAGE");
            }
        },
        columns() {
            return [
                {
                    title: this.$t("phumVillage.cityProvince"),
                    key: "commune",
                    render: (h, params) => {
                        return h(
                            "span",
                            params.row.commune &&
                                params.row.commune.district &&
                                params.row.commune.district.province
                                ? params.row.commune.district.province.name_en
                                : "-"
                        );
                    },
                    width: 160
                },
                {
                    title: this.$t("phumVillage.khanDistrict"),
                    key: "commune",
                    render: (h, params) => {
                        return h(
                            "span",
                            params.row.commune && params.row.commune.district
                                ? params.row.commune.district.name_en
                                : "-"
                        );
                    },
                    width: 160
                },
                {
                    title: this.$t("phumVillage.sangkatCommune"),
                    key: "commune",
                    render: (h, params) => {
                        return h(
                            "span",
                            params.row.commune
                                ? params.row.commune.name_en
                                : "-"
                        );
                    },
                    width: 160
                },
                {
                    title: this.$t("phumVillage.nameKhTitle"),
                    key: "name_kh"
                },
                {
                    title: this.$t("phumVillage.nameEnTitle"),
                    key: "name_en"
                },
                {
                    title: this.$t("phumVillage.chiefName"),
                    key: "village_chief_name",
                    width: 160
                },
                {
                    title: this.$t("phumVillage.chiefPhone"),
                    key: "village_phone_number",
                    width: 160
                },
                {
                    title: this.$t("phumVillage.numberOfFamily"),
                    key: "number_of_family",
                    align: "center",
                    width: 150
                },
                {
                    title: this.$t("phumVillage.totalMale"),
                    key: "total_male",
                    align: "center"
                },
                {
                    title: this.$t("phumVillage.totalFemale"),
                    key: "total_female",
                    align: "center"
                },
                {
                    title: this.$t("actions"),
                    key: "action",
                    slot: "action",
                    align: "center",
                    className: "tw-space-x-2",
                    width: 90
                }
            ];
        }
    },
    methods: {
        fetchData(attributes) {
            this.loading = true;
            this.$store
                .dispatch("corporate/phumVillage/fetch", {
                    ...attributes
                })
                .then(() => {
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.notice({ type: "error", text: error.message });
                });
        },
        onEdit(record) {
            this.$store.commit("corporate/phumVillage/SET_EDIT_DATA", record);
            this.showForm = true;
            this.$refs.form_action.setEditData();
        },
        clearEdit() {
            this.showForm = false;
            this.$refs.form_action.setEditData();
            this.$refs.form_action.clearInput();
            this.$store.commit("corporate/phumVillage/SET_EDIT_DATA", {});
        },
        addNew() {
            this.$store.commit("corporate/phumVillage/SET_EDIT_DATA", {});
            this.showForm = true;
            this.$refs.form_action.setEditData();
            this.$refs.form_action.clearInput();
        },

        async onDelete(record) {
            record._deleting = true;
            this.$store
                .dispatch("corporate/phumVillage/destroy", record.village_code)
                .then(response => {
                    this.fetchData();
                    record._deleting = false;
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                })
                .catch(error => {
                    this.notice({ type: "error", text: error.message });
                    record._deleting = false;
                });
        },

        notice(not) {
            this.$Notice[not.type]({
                title: "PHUM VILLAGE",
                desc: not.text
            });
        }
    },
    watch: {
        search: debounce(function(search) {
            this.fetchData({ search });
        }, 500)
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("corporate/phumVillage/RESET_STATE");
        next();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchData();
        });
    }
};
</script>
